export enum FavoriteStoreMethod {
    Add = 'add',
    Remove = 'remove',
}
